export const CALL_TRIAGE_PRIORITIES = ['Low', 'Moderate', 'High', 'Critical']

const priorityRank = {
  Low: 0,
  Moderate: 1,
  High: 2,
  Critical: 3,
}

const priorityFromRank = (rank) =>
  CALL_TRIAGE_PRIORITIES[Math.max(0, Math.min(3, Number(rank) || 0))]

const normaliseValue = (value) =>
  typeof value === 'string' ? value.trim().toLowerCase() : value

const doesRuleMatch = (answer, when = {}) => {
  const operator = when.operator
  const expected = when.value
  const exists = answer !== undefined && answer !== null && answer !== ''

  if (operator === 'exists') return exists
  if (operator === 'notExists') return !exists
  if (!exists) return false

  const normalAnswer = normaliseValue(answer)
  const normalExpected = normaliseValue(expected)

  if (operator === 'equals') return normalAnswer === normalExpected
  if (operator === 'notEquals') return normalAnswer !== normalExpected
  if (operator === 'contains') {
    if (Array.isArray(answer)) return answer.map(normaliseValue).includes(normalExpected)
    return String(normalAnswer).includes(String(normalExpected))
  }
  if (operator === 'notContains') {
    if (Array.isArray(answer)) return !answer.map(normaliseValue).includes(normalExpected)
    return !String(normalAnswer).includes(String(normalExpected))
  }

  const answerNumber = Number(answer)
  const expectedNumber = Number(expected)
  if (Number.isNaN(answerNumber) || Number.isNaN(expectedNumber)) return false

  if (operator === 'greaterThan') return answerNumber > expectedNumber
  if (operator === 'greaterThanOrEqual') return answerNumber >= expectedNumber
  if (operator === 'lessThan') return answerNumber < expectedNumber
  if (operator === 'lessThanOrEqual') return answerNumber <= expectedNumber
  return false
}

export const calculateSuggestedPriority = ({
  defaultPriority = 'Moderate',
  questions = [],
  answers = {},
}) => {
  let calculatedRank = priorityRank[defaultPriority] ?? priorityRank.Moderate
  const warnings = []
  const triggeredRules = []
  let overrideReasonRequired = false

  ;[...(questions ?? [])]
    .sort((a, b) => (a.order ?? 0) - (b.order ?? 0))
    .forEach((question) => {
      const answer = answers[String(question._id)]

      ;[...(question.rules ?? [])]
        .sort((a, b) => (a.order ?? 0) - (b.order ?? 0))
        .forEach((rule) => {
          if (!doesRuleMatch(answer, rule.when)) return

          const action = rule.action ?? {}
          if (action.type === 'setPriority') {
            calculatedRank = priorityRank[action.priority] ?? calculatedRank
          }
          if (action.type === 'minimumPriority') {
            calculatedRank = Math.max(
              calculatedRank,
              priorityRank[action.priority] ?? calculatedRank,
            )
          }
          if (action.type === 'increasePriority') {
            calculatedRank = Math.min(3, calculatedRank + (Number(action.levels) || 1))
          }
          if (action.type === 'decreasePriority') {
            calculatedRank = Math.max(0, calculatedRank - (Number(action.levels) || 1))
          }
          if (action.type === 'showWarning' && action.message) warnings.push(action.message)
          if (action.type === 'requireOverrideReason') {
            overrideReasonRequired = true
            if (action.message) warnings.push(action.message)
          }

          triggeredRules.push({
            questionId: question._id,
            questionText: question.text,
            answer,
            action,
          })
        })
    })

  return {
    defaultPriority,
    calculatedPriority: priorityFromRank(calculatedRank),
    triggeredRules,
    warnings,
    overrideReasonRequired,
  }
}

export const callTriageAcknowledgementText =
  'These call triage categories, presenting complaints, suggested priorities, questions, and rules are provided by AmbuNet as configurable reference templates only. They are not a clinical protocol, dispatch protocol, or substitute for clinical judgement.\n\nYour organisation is responsible for reviewing, approving, maintaining, and governing this configuration before operational use.\n\nBy approving this configuration, you confirm that your organisation accepts responsibility for its suitability and use.'
